export default __webpack_public_path__ + "static/media/NoData.1e031cae.svg";